ready().then(function() {

    const footerFunctions = () => {
        const footer = document.querySelector('footer');
        
        if(typeof(footer) != 'undefined' && footer != null) {
            /*
            *  We like to have a state to see in the DOM which footer menu is active - so add some data attributes
            */
            function addStateToFooterMenu() {
                if (window.screen.width < mdWidth ) { // Only on the smallest devices
                    footer.setAttribute('data-footer-menu-state', 'mobile');
                }
                if (window.screen.width >= mdWidth ) { // Only on the smallest devices
                    footer.setAttribute('data-footer-menu-state', 'desktop');
                }
            }
            
            addStateToFooterMenu();
        }
    }

    footerFunctions();
});